import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { formatLatexPreview } from "../../../../components/inputs/FractionInput";
import InlineKeepTogether from "../../../../components/ui/InlineKeepTogether";
import { checkFractionAnswer, latexFrac, makeUid, pick, simplify } from "./probabilityEventUtils";

function makeData() {
  const denominator = pick([8, 10, 12, 15, 20]);
  const numerator = pick(Array.from({ length: denominator - 2 }, (_, i) => i + 1));
  const answer = simplify(denominator - numerator, denominator);
  return { numerator, denominator, answer };
}

export function generateTask() {
  return {
    type: "ComplementProbabilityTask",
    uid: makeUid("prob_complement"),
    data: makeData()
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", margin: "12px 0" }}>
      Dla zdarzenia <InlineMath math="A" /> mamy{" "}
      <InlineKeepTogether>
        <InlineMath math={`P(A)=${latexFrac(data.numerator, data.denominator)}`} />.
      </InlineKeepTogether>{" "}
      Oblicz prawdopodobieństwo zdarzenia przeciwnego{" "}
      <InlineKeepTogether>
        <InlineMath math={"A'"} />.
      </InlineKeepTogether>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-3">
      <InlineMath math={"P(A') = "} />
      <FractionInput value={userAnswer} onChange={onChange} disabled={disabled} label="P(A')" placeholder="np. 3/4" />
    </div>
  );
}

export function checkAnswer({ data }, userAnswer) {
  return checkFractionAnswer(data.answer, userAnswer);
}

export function renderAnswer({ data }) {
  return <InlineMath math={`P(A')=${latexFrac(data.answer[0], data.answer[1])}`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(userAnswer.raw, "P(A')")} />;
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.75 }}>
      <p><strong>Krok 1.</strong> Zdarzenie przeciwne obejmuje wszystkie wyniki spoza zdarzenia <InlineMath math="A" />.</p>
      <BlockMath math={"P(A')=1-P(A)"} />
      <p><strong>Krok 2.</strong> Podstawiamy dane.</p>
      <BlockMath math={`P(A')=1-${latexFrac(data.numerator, data.denominator)}=${latexFrac(data.denominator - data.numerator, data.denominator)}=${latexFrac(data.answer[0], data.answer[1])}`} />
      <p><strong>Odpowiedź:</strong> <InlineKeepTogether><InlineMath math={`P(A')=${latexFrac(data.answer[0], data.answer[1])}`} />.</InlineKeepTogether></p>
    </div>
  );
}
